import { render, staticRenderFns } from "./SmartAbVerdictBanner.vue?vue&type=template&id=271ab812&scoped=true&"
import script from "./SmartAbVerdictBanner.vue?vue&type=script&lang=ts&"
export * from "./SmartAbVerdictBanner.vue?vue&type=script&lang=ts&"
import style0 from "./SmartAbVerdictBanner.vue?vue&type=style&index=0&id=271ab812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271ab812",
  null
  
)

export default component.exports